import { useQuery } from '@tanstack/react-query';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
const STALE_TIME_MS = 1000 * 30;
// A creator's giveaway reward pool for the redesign profile (legacy GET_USER_GIVEAWAY_REWARDS).
export const useCreatorGiveawayRewards = (userId, recordId) => {
    var _a;
    const { fetcher } = useDareDropApi();
    const query = useQuery({
        queryKey: ['creator-giveaway-rewards', userId, recordId],
        queryFn: () => fetcher({
            endpointId: giveawayEndpointIds.GET_USER_GIVEAWAY_REWARDS,
            payload: { userId, recordId },
        }),
        enabled: Boolean(userId || recordId),
        staleTime: STALE_TIME_MS,
    });
    return {
        rewards: (_a = query.data) !== null && _a !== void 0 ? _a : [],
        isLoading: query.isLoading,
    };
};
